import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { routerReducer } from 'react-router-redux';
import * as formNormalizers from '../services/form-normalizers';
import appSettings from './app-settings';
import auth from './auth';
import breadcrumbsWidget from './breadcrumbs-widget';
import commentForm from './comment-form';
import comments from './comments';
import communitiesContext from './communities-context';
import commentEdit from './edited-comment-id';
import experiments from './experiments';
import followers from './followers';
import following from './following';
import forumData from './forum-data';
import header from './header';
import isDemoMode from './is-demo-mode';
import isLoaded from './is-loaded';
import isLoading from './is-loading';
import locationHistory from './location-history';
import members from './members';
import message from './message';
import modal from './modal';
import newPostMessage from './new-post-message';
import notifications from './notifications';
import pagination from './pagination';
import posts from './posts';
import profileForm from './profile-form';
import search from './search';
import siteInfo from './site-info';
import sitePages from './site-pages';
import socket from './socket-io';
import categories from './categories';
import textEditor from './text-editor';
import typing from './typing';
import users from './users';
import viewMode from './view-mode';
import userAgent from './user-agent';

export default combineReducers({
  appSettings,
  auth,
  breadcrumbsWidget,
  comments,
  communitiesContext,
  commentEdit,
  experiments,
  followers,
  following,
  forumData,
  header,
  isDemoMode,
  isLoaded,
  isLoading,
  locationHistory,
  members,
  message,
  modal,
  newPostMessage,
  notifications,
  pagination,
  posts,
  routing: routerReducer,
  search,
  siteInfo,
  sitePages,
  socket,
  categories,
  textEditor,
  typing,
  users,
  userAgent,
  viewMode,
  form: formReducer
    .plugin({
      comment: commentForm,
      profile: profileForm,
    })
    .normalize(formNormalizers),
});

export const modalRootReducer = combineReducers({
  auth,
  appSettings,
  communitiesContext,
  experiments,
  forumData,
  modal,
  routing: routerReducer,
  categories,
  users,
  userAgent,
  form: formReducer.normalize(formNormalizers),
});



// WEBPACK FOOTER //
// ./app/reducers/index.js